import React from "react";
import { CircleLoading } from "../assets/Icons";


const BtnLoad = () => {
  return (
    <div className="loading-button">
      <CircleLoading />
    </div>
  );
};

export default BtnLoad;
